export default "__VITE_ASSET__Cem_b6DW__"